<template>
  <a-modal
    :open="open"
    :title="null"
    :footer="null"
    @cancel="handleClose"
    :maskClosable="false"
    centered
  >
    <section class="container">
      <DeleteOutlined class="icon" />

      <h2>¿Estás seguro de eliminar el conector “{{ connector?.name }}”</h2>

      <div class="container__info">
        <h4>Sucederá lo siguiente:</h4>
        <ul>
          <li>Al eliminar el conector, este dejará de estar disponible y se quitará de la sección de Conectores de API.</li>
        </ul>
      </div>

      <a-form class="form" layout="vertical">
        <a-row :gutter="24">
          <a-col span="24">
            <a-form-item class="form__item">
              <template #label>
                <span class="icon-required">*</span>
                <span> Escribe la palabra <span class="strong">"Eliminar"</span> </span>
              </template>
              <a-auto-complete
                :status="isTextIncorrect ? 'error' : ''"
                v-model:value="confirmText"
                placeholder="Escribe aquí..."
                :class="{ 'ant-form-item-has-error': isTextIncorrect }"
              />
              <!-- <p v-if="isTextIncorrect" class="form__error">Palabra inválida</p> -->
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <div class="button__disabled--block">
        <a-tooltip style="width: 100%">
          <template #title v-if="confirmText !== 'Eliminar'">
            Completa el campo requerido para eliminar el conector de API.
          </template>
          <a-button
            style="width: 100%"
            :disabled="confirmText !== 'Eliminar'"
            class="footer__delete"
            type="primary"
            @click="onDelete(connector.id)"
          >
            Eliminar conector de API
          </a-button>
        </a-tooltip>
      </div>
    </section>
  </a-modal>
</template>

<script setup lang="ts">
import { DeleteOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, toRefs, computed } from "vue";

import { connectorServices } from "@/app/ivr/bot/services/ConnectorServices";
import { Connector } from "@/@types/ivr";

const props = defineProps<{
  open: boolean;
  connector: Connector;
}>();

const { connector } = toRefs(props);

const emit = defineEmits<{
  "update:open": [open: boolean];
  update: [];
}>();

const handleClose = () => {
  emit("update:open", false);
};

const isLoading = ref<boolean>(false);

const confirmText = ref("");

const isTextIncorrect = computed(() => {
  return confirmText.value != "Eliminar" && confirmText.value.length > 0;
})

const onDelete = async (connectorId: number) => {
  try {
    isLoading.value = true;
    await connectorServices.delete(connectorId);
    message.success("Se eliminó exitosamente");
    emit("update:open", false);
    emit("update");
  } catch (error) {
    message.error("Error al eliminar");
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped lang="sass">
.container
  padding: 24px

.icon
  font-size: 64px
  color: $red-6
  margin-bottom: 16px
  width: 100%
  justify-content: center

h2
  margin-bottom: 12px
  font-size: 16px
  font-weight: 600
  text-align: center

p
  margin-bottom: 12px

.button
  width: 100%
  margin-top: 16px

:deep(.button__disabled--block .ant-tooltip-disabled-compatible-wrapper)
  width: 100% !important

.container__info
  margin-bottom: 18px

</style>
